module.exports = __webpack_public_path__ + "static/media/me_wedding_compressed_cropped_3.52043df9.jpg";